import { useState, useEffect } from "react";
import {
  Box,
  FormControlLabel,
  Grid2,
  IconButton,
  Switch,
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSelect from "../../../../components/MaterialSelect";
import colors from "../../../../assest/theme/base/colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import MessagePopup from "../../../Utils/MessagePopup";
import ConfirmDialog from "../../../Utils/ConfirmDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import axiosInstance, { API_URL } from "../../../Utils/url";
import { useSnackbar } from "../../../../components/SnackbarProvider";
import { useLoading } from "../../../../context/loadingcontext";

const Addplan = ({ formClose, formType, setOpen, rowId }) => {
  const [insurerdata, setinsurerdata] = useState({
    planname: "",
    insurer: "",
    annualcoveragedays: "",
    dailycashbenefit: "",
    accidentcover: "",
    hospitalcashlimit: "",
    netpremium: "",
    gst: "",
    wellnessbenefit: "",
    uploadedFile: null,
    active: true,
    plannameStatus: "unchecked",
    insurerStatus: "unchecked",
    famdefinition: "",
    preamount: "",
    famdefinitionStatus: "unchecked",
    preamountStatus: "unchecked",
    annualcoveragedaysStatus: "unchecked",
    dailycashbenefitStatus: "unchecked",
    accidentcoverStatus: "unchecked",
    hospitalcashlimitStatus: "unchecked",
    netpremiumStatus: "unchecked",
    gstStatus: "unchecked",
    wellnessbenefitStatus: "unchecked",
  });
  const [inputStatus, setinputStatus] = useState(false);
  const { showSnackbar } = useSnackbar();
  const { setCirleLoading } = useLoading();
  const [insurenceNameOptions, setInsurenceNameOptions] = useState([]);
  const [plansNameOptions, setPlansNameOptions] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    fetchInsurenceName();
  }, []);
  useEffect(() => {
    if (formType == "view") {
      setinputStatus(true);
    } else {
      setinputStatus(false);
    }
    fetchPlanById();
  }, [formType]);

  const fetchPlanById = async () => {
    try {
      const response = await axiosInstance.get(
        `${API_URL}v1/insurance-plan/${rowId}/`
      );

      const success = response?.data?.success;
      const data = response?.data?.data;

      const family_configurations = data?.family_configurations?.map(
        (entry) => ({
          family_definition: entry?.family_definition,
          net_premium: entry?.premium_amount,
          gst: entry?.gst,
          premium_amount: entry?.total_amount,
        })
      );

      setEntries(family_configurations);

      setinsurerdata({
        planname: { value: data?.insurance_plan, label: data?.plan_name },
        insurer: {
          value: data?.insurance_configuration,
          label: data?.insurance_name,
        },
        annualcoveragedays: data?.annual_coverage_days,
        dailycashbenefit: data?.daily_cash_benefit,
        accidentcover: data?.accident_cover,
        hospitalcashlimit: data?.hospital_cash_limit,
        netpremium: "",
        gst: "",
        wellnessbenefit: data?.wellness_benefit,

        active: data?.is_active,
        plannameStatus: "success",
        insurerStatus: "success",
        famdefinition: "",
        preamount: "",
        famdefinitionStatus: "success",
        preamountStatus: "success",
        annualcoveragedaysStatus: "success",
        dailycashbenefitStatus: "success",
        accidentcoverStatus: "success",
        hospitalcashlimitStatus: "success",
        netpremiumStatus: "success",
        gstStatus: "success",
        wellnessbenefitStatus: "success",
      });
    } catch (err) {
    } finally {
    }
  };

  const fetchInsurenceName = async () => {
    try {
      const response = await axiosInstance.get(`${API_URL}v1/insurance-name/`);

      setInsurenceNameOptions(response?.data?.data);
    } catch (error) {
      setInsurenceNameOptions([]);
    }
  };

  const fetchPlans = async (id) => {
    try {
      const response = await axiosInstance.get(
        `${API_URL}v1/insurance-plans/${id}/`
      );
      setPlansNameOptions(response?.data?.data);
    } catch (error) {}
  };

  const handleAddCourseChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...insurerdata };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "insurer") {
        fetchPlans(event?.value);
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "planname") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "famdefinition":
          {
            const alphaNLengthRegex = new RegExp("^.{1,500}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "preamount":
          {
            const alphaNLengthRegex = new RegExp("^.{1,5000}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "annualcoveragedays":
          {
            const alphaNLengthRegex = new RegExp("^.{1,5000}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "wellnessbenefit":
          {
            const alphaNLengthRegex = new RegExp("^.{1,500}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "dailycashbenefit":
          {
            const alphaNLengthRegex = new RegExp("^.{1,5000}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "accidentcover":
          {
            const alphaNLengthRegex = new RegExp("^.{1,5000}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "hospitalcashlimit":
          {
            const alphaNLengthRegex = new RegExp("^.{1,500}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "netpremium":
          {
            const alphaNLengthRegex = new RegExp("^.{1,500}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "gst":
          {
            const alphaNLengthRegex = new RegExp("^.{1,500}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setinsurerdata(formState);
  };

  const hanldeConfirmDialogCancel = () => {
    setDialogOpen(false);
  };

  const handleSubmit = () => {
    setDialogOpen(true);
  };

  const reset = () => {
    setinsurerdata({
      ...insurerdata,
      planname: "",
      insurer: "",
      annualcoveragedays: "",
      dailycashbenefit: "",
      accidentcover: "",
      hospitalcashlimit: "",
      wellnessbenefit: "",
      uploadedFile: null,
      active: true,
      famdefinition: "",
      preamount: "",
      netpremium: "",
      gst: "",
      plannameStatus: "unchecked",
      insurerStatus: "unchecked",
      famdefinitionStatus: "unchecked",
      preamountStatus: "unchecked",
      annualcoveragedays: "unchecked",
      dailycashbenefit: "unchecked",
      accidentcover: "unchecked",
      hospitalcashlimit: "unchecked",
      netpremiumStatus: "unchecked",
      gstStatus: "unchecked",
      wellnessbenefitStatus: "unchecked",
    });
    formClose();

    setEntries([]);
  };

  const isFormValid = () => {
    return insurerdata.plannameStatus == "success";
  };

  const hanldeConfirmDialogSubmit = async () => {
    setDialogOpen(false);
    setCirleLoading(true);

    try {
      const family_configurations = entries?.map((entry) => ({
        family_definition: entry?.family_definition,
        premium_amount: entry?.net_premium,
        gst: entry?.gst,
        total_amount: entry?.premium_amount,
      }));

      const data = {
        insurance_configuration: insurerdata?.insurer?.value,
        insurance_plan: insurerdata?.planname?.value,
        annual_coverage_days: insurerdata?.annualcoveragedays,
        daily_cash_benefit: insurerdata?.dailycashbenefit,
        accident_cover: insurerdata?.accidentcover,
        hospital_cash_limit: insurerdata?.hospitalcashlimit,
        wellness_benefit: insurerdata?.wellnessbenefit,
        family_configurations: family_configurations,
      };

      const response =
        formType == "edit"
          ? await axiosInstance.put(
              `${API_URL}v1/insurance-plan/${rowId}/`,
              data
            )
          : await axiosInstance.post(`${API_URL}v1/insurance-plan/`, data);
      setOpen(false);
      showSnackbar(response?.data?.message, "success");
    } catch (err) {
      showSnackbar(err?.response?.data?.message, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  const handleToggleActive = () => {
    setinsurerdata((prev) => ({
      ...prev,
      wellnessbenefit: !prev.wellnessbenefit,
    }));
  };

  const handleDeleteEntry = (indexToDelete) => {
    setEntries((prev) => prev.filter((_, i) => i !== indexToDelete));
  };

  const handleAddEntry = () => {
    const {
      famdefinition,
      preamount,
      famdefinitionStatus,
      preamountStatus,
      netpremiumStatus,
      gstStatus,
      netpremium,
      gst,
    } = insurerdata;

    // Validation
    if (
      famdefinitionStatus !== "success" ||
      preamountStatus !== "success" ||
      netpremiumStatus != "success" ||
      gstStatus != "success"
    ) {
      return;
    }

    setEntries((prev) => [
      ...prev,
      {
        family_definition: famdefinition,
        premium_amount: preamount,
        net_premium: netpremium,
        gst: gst,
      },
    ]);

    // Clear input fields
    setinsurerdata({
      ...insurerdata,
      famdefinition: "",
      preamount: "",
      netpremium: "",
      gst: "",
      famdefinitionStatus: "unchecked",
      preamountStatus: "unchecked",
      netpremiumStatus: "unchecked",
      gstStatus: "unchecked",
    });
  };

  return (
    <>
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title="Confirm Popup"
        content="Are you sure you want to submit this record?"
        onClose={hanldeConfirmDialogCancel}
        onConfirm={hanldeConfirmDialogSubmit}
      />
      <Box sx={{ p: 3, mx: "auto", borderRadius: 2 }}>
        {/* <Loader isLoading={isLoading} /> */}
        <MessagePopup
          message={popup.message}
          severity={popup.severity}
          open={popup.open}
          setPopup={setPopup}
        />
        <ConfirmDialog
          open={dialogOpen}
          title="Confirm Popup"
          content="Are you sure you want to submit this record?"
          onClose={hanldeConfirmDialogCancel}
          onConfirm={hanldeConfirmDialogSubmit}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: 4 }}>
            <IconButton onClick={formClose}>
              <ArrowBackIcon sx={{ color: "#000" }} />
            </IconButton>{" "}
            <MaterialTypography
              sx={{ fontSize: "18px", fontWeight: "bold", mt: 2 }}
              mb={2}
            >
              New Plan
            </MaterialTypography>
          </Box>
          <IconButton onClick={formClose}>
            <ClearIcon sx={{ color: "#000" }} />
          </IconButton>
        </Box>
        <Grid2 container spacing={1.5} sx={{ alignItems: "end" }}>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Insurer
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="insurer"
              placeholder={`Select Insurer`}
              value={insurerdata.insurer}
              options={insurenceNameOptions?.map((v) => ({
                value: v?.id,
                label: v?.insurance_name,
              }))}
              searchable={false}
              onChange={handleAddCourseChange}
              error={insurerdata.insurerStatus === "error" ? true : false}
              success={insurerdata.insurerStatus === "success" ? true : false}
              isDisabled={inputStatus}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Plan
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="planname"
              placeholder={`Select plan`}
              value={insurerdata.planname}
              options={plansNameOptions?.map((v) => ({
                value: v?.id,
                label: v?.plan_name,
              }))}
              searchable={false}
              onChange={handleAddCourseChange}
              error={insurerdata.plannameStatus === "error" ? true : false}
              success={insurerdata.plannameStatus === "success" ? true : false}
              isDisabled={insurerdata.insurer == "" ? true : inputStatus}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Coverage Days in a Year
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="annualcoveragedays"
              placeholder="Enter Coverage days"
              value={insurerdata.annualcoveragedays}
              onChange={handleAddCourseChange}
              error={
                insurerdata.annualcoveragedaysStatus === "error" ? true : false
              }
              success={
                insurerdata.annualcoveragedaysStatus === "success"
                  ? true
                  : false
              }
              disabled={inputStatus}
            />
            {insurerdata.annualcoveragedaysStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Annual Coverage days must be in number and should not exceed
                combination of 5 digits.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              WellNess Benefit
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="wellnessbenefit"
              placeholder="Enter Cash Benefit"
              value={insurerdata.wellnessbenefit}
              onChange={handleAddCourseChange}
              error={
                insurerdata.wellnessbenefitStatus === "error" ? true : false
              }
              success={
                insurerdata.wellnessbenefitStatus === "success" ? true : false
              }
              disabled={inputStatus}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Hospital Daily Cash Benefit
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="dailycashbenefit"
              placeholder="Enter Cash Benefit"
              value={insurerdata.dailycashbenefit}
              onChange={handleAddCourseChange}
              error={
                insurerdata.dailycashbenefitStatus === "error" ? true : false
              }
              success={
                insurerdata.dailycashbenefitStatus === "success" ? true : false
              }
              disabled={inputStatus}
            />
            {insurerdata.dailycashbenefitStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Daily Cash Benefit must be in number and should not exceed
                combination of 5 digits.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Personal Accident Benefit
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="accidentcover"
              placeholder="Enter Cash Benefit"
              value={insurerdata.accidentcover}
              onChange={handleAddCourseChange}
              error={insurerdata.accidentcoverStatus === "error" ? true : false}
              success={
                insurerdata.accidentcoverStatus === "success" ? true : false
              }
              disabled={inputStatus}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Hospital Cash Limit
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="hospitalcashlimit"
              placeholder="Enter Cash Limit"
              value={insurerdata.hospitalcashlimit}
              onChange={handleAddCourseChange}
              error={
                insurerdata.hospitalcashlimitStatus === "error" ? true : false
              }
              success={
                insurerdata.hospitalcashlimitStatus === "success" ? true : false
              }
              disabled={inputStatus}
            />
            {insurerdata.hospitalcashlimitStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Hospital Cash Limit must be in number and should not exceed
                combination of 20 digits.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Hospital Cash Total Sum Insured per family in a year
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="famdefinition"
              placeholder="Enter Family Definition"
              value={insurerdata.famdefinition}
              onChange={handleAddCourseChange}
              error={insurerdata.famdefinitionStatus === "error" ? true : false}
              success={
                insurerdata.famdefinitionStatus === "success" ? true : false
              }
              disabled={inputStatus}
            />
            {insurerdata.famdefinitionStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Family Definition must be 1 to 50 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 4, md: 4 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Total Premium Amount
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="preamount"
              placeholder="Enter Premium Amount"
              value={insurerdata.preamount}
              onChange={handleAddCourseChange}
              error={insurerdata.preamountStatus === "error" ? true : false}
              success={insurerdata.preamountStatus === "success" ? true : false}
              disabled={inputStatus}
            />
            {insurerdata.preamountStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Premium Amount must be in number and should not exceed
                combination of 5 digits..
              </MaterialTypography>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 4, md: 4 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Net Premium Amount
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="netpremium"
              placeholder="Enter Net Premium"
              value={insurerdata.netpremium}
              onChange={handleAddCourseChange}
              error={insurerdata.netpremiumStatus === "error" ? true : false}
              success={
                insurerdata.netpremiumStatus === "success" ? true : false
              }
              disabled={inputStatus}
            />
            {insurerdata.netpremiumStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Net Premium must be in number and should not exceed combination
                of 5 digits.
              </MaterialTypography>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 4, md: 4 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              GST
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="gst"
              placeholder="Enter GST"
              value={insurerdata.gst}
              onChange={handleAddCourseChange}
              error={insurerdata.gstStatus === "error" ? true : false}
              success={insurerdata.gstStatus === "success" ? true : false}
              disabled={inputStatus}
            />
            {insurerdata.gstStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                GST must be in number and should not exceed combination of 5
                digits.
              </MaterialTypography>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 2, md: 2 }}>
            <IconButton onClick={handleAddEntry}>
              <AddCircleIcon sx={{ color: colors.iconcolor }} />
            </IconButton>
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }} sx={{ paddingLeft: "2%" }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel, Opacity: "0" }}
            >
              Available/Not Available
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <FormControlLabel
              control={
                <Switch
                  checked={insurerdata.active}
                  onChange={handleToggleActive}
                  color="primary"
                  disabled={inputStatus}
                />
              }
              disabled={inputStatus}
              label={insurerdata.active ? "Active" : "Inactive"}
            />
          </Grid2>
          {entries.length > 0 && (
            <Grid2 size={{ xs: 12, md: 12, md: 12 }}>
              <div
                style={{
                  maxWidth: 800,
                  margin: "20px auto",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid #ccc",
                    fontSize: "12px",
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#f2f2f2" }}>
                      <th
                        style={{
                          textAlign: "left",
                          padding: 8,
                          border: "1px solid #ccc",
                        }}
                      >
                        No
                      </th>
                      <th
                        style={{
                          textAlign: "left",
                          padding: 4,
                          border: "1px solid #ccc",
                        }}
                      >
                        Family Definition
                      </th>
                      <th
                        style={{
                          textAlign: "left",
                          padding: 4,
                          border: "1px solid #ccc",
                        }}
                      >
                        Net Premium
                      </th>
                      <th
                        style={{
                          textAlign: "left",
                          padding: 4,
                          border: "1px solid #ccc",
                        }}
                      >
                        GST
                      </th>
                      <th
                        style={{
                          textAlign: "left",
                          padding: 4,
                          border: "1px solid #ccc",
                        }}
                      >
                        Total Premium Amount
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          padding: 4,
                          border: "1px solid #ccc",
                        }}
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {entries.length === 0 ? (
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            padding: 4,
                            textAlign: "center",
                            color: "gray",
                            fontStyle: "italic",
                            border: "1px solid #ccc",
                          }}
                        >
                          No data available.
                        </td>
                      </tr>
                    ) : (
                      entries.map((entry, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              padding: "2px 8px",
                              border: "1px solid #ccc",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              padding: "2px 8px",
                              border: "1px solid #ccc",
                            }}
                          >
                            {entry.family_definition}
                          </td>
                          <td
                            style={{
                              padding: "2px 8px",
                              border: "1px solid #ccc",
                            }}
                          >
                            {entry.net_premium}
                          </td>
                          <td
                            style={{
                              padding: "2px 8px",
                              border: "1px solid #ccc",
                            }}
                          >
                            {entry.gst}
                          </td>
                          <td
                            style={{
                              padding: "2px 8px",
                              border: "1px solid #ccc",
                            }}
                          >
                            {entry.premium_amount}
                          </td>
                          <td
                            style={{
                              padding: "2px 8px",
                              textAlign: "center",
                              border: "1px solid #ccc",
                            }}
                          >
                            <IconButton
                              onClick={() => handleDeleteEntry(index)}
                              color="error"
                            >
                              <DeleteIcon sx={{ color: colors.iconcolor }} />
                            </IconButton>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </Grid2>
          )}

          <Grid2 size={{ xs: 12, md: 12, md: 12 }}>
            <Box display="flex" justifyContent="space-around" mt={3}>
              {inputStatus == false && (
                <MaterialButton
                  variant="contained"
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                  onClick={handleSubmit}
                  disabled={!isFormValid()}
                >
                  Submit
                </MaterialButton>
              )}
              <MaterialButton
                onClick={reset}
                variant="outlined"
                sx={{
                  color: colors.cancel,
                  borderColor: colors.cancel,
                  "&:hover": {
                    borderColor: colors.cancel,
                  },
                }}
              >
                Cancel
              </MaterialButton>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default Addplan;
